<template>
  <!--top header-->
  <div class="top_header">
    <!--top-->
    <div class="top">
      <div class="main">
        <div>
          <div style="float: left;">
            <p>您好，欢迎访问上海欧淮贸易有限公司官网！</p>
          </div>
          <div style="clear: both;"></div>
        </div>
      </div>
    </div>

    <!--navigation-->
    <div class="navigation text-center">
      <div class="main">
        <!--logo-->
          <div class="logo">
            <img src="@/assets/logo1.png" class="img-responsive">
          </div>
        <ul class="clearfix">
          <li><router-link to="/home">网站首页</router-link></li>
          <li><router-link to="/about">公司简介</router-link></li>
          <li><router-link to="/news">新闻中心</router-link></li>
          <li><router-link to="/product">产品中心</router-link></li>
          <li><router-link to="/contractUs">联系我们</router-link></li>
          <div style="clear: both;"></div>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Header'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
